import actionTypes from './actionTypes';
import { CONTRACT_ACTIONS } from '../constants';
import type { ContractTabActionKey } from '../constants';
import type { IContractPageBody } from '../sharedTypes';
import type { ILoadContractRequestPayload } from './types';

const actions = {
  loadContractRequest: (payload: ILoadContractRequestPayload) => ({
    type: actionTypes.LOAD_CONTRACT_REQUEST,
    payload,
  }),
  loadContractSuccess: (contract: IContractPageBody, tab: ContractTabActionKey = CONTRACT_ACTIONS.CURRENT_SHOW) => ({
    type: actionTypes.LOAD_CONTRACT_SUCCESS,
    payload: { contract, tab },
  }),
  loadContractLegacy: () => ({ type: actionTypes.LOAD_CONTRACT_LEGACY }),
  loadContractError: (notFound = false, message: string | null = null) => ({
    type: actionTypes.LOAD_CONTRACT_ERROR,
    payload: { notFound, message },
  }),
  // The create returns the full page body, so the contract page opens without a second request.
  seedContract: (contract: IContractPageBody) => ({ type: actionTypes.SEED_CONTRACT, payload: { contract } }),
  clearStore: () => ({ type: actionTypes.CLEAR_STORE }),
};

export default actions;
